import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import Coursefresher from '../Components/Coursefresher/Coursefresher'
import Courseprof from '../Components/Courseprof/Courseprof'
import Courseonline from '../Components/Courseonline/Courseonline'
import { Helmet } from 'react-helmet'

const Coursecal = () => {
  return (
    <div>
        <Helmet>
        <title>Takshila VLSI training institute offers training in Physical design, ASIC verification, custom layout or analog layout at affordable low prices</title>
        <meta name="description" content="Explore the course schedule at Takshila VLSI Institute for comprehensive VLSI training in Bangalore and Hyderabad. Start your journey today!" />
        <link rel="canonical" href="https://www.takshila-vlsi.com/course-calendar/" />
        <link rel="next" href="https://www.takshila-vlsi.com/course-calendar/page/2/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Takshila VLSI training institute offers training in Physical design, ASIC verification, custom layout or analog layout at affordable low prices" />
        <meta property="og:description" content="Explore the course schedule at Takshila VLSI Institute for comprehensive VLSI training in Bangalore and Hyderabad. Start your journey today!" />
        <meta property="og:url" content="https://www.takshila-vlsi.com/course-calendar/" />
        <meta property="og:site_name" content="Takshila VLSI" />
        <meta property="article:modified_time" content="2024-11-28T13:17:52+00:00" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
    <Header/>
    <main>
    <section className='section-banner pg-banner mb-5 p-lg-5 pt-4'>
            <div class="container text-center">
                          <div class="row justify-content-around">
                              <div class="col-md">
                              <div class="pg-title-sec bg-3 dark-bg p-lg-5 p-3">
                                    <h1 className='pg-title pb-3'>Courses Calendar</h1>
                                    <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.
                                    </p>
                                </div>
                              </div>
                              <div>
                              </div>
                          </div>
            </div>
          </section>   
    
          <section className='course-grid pb-5'>
          <div class="container">
            <div class="my-5 bg-5 p-3 dark-bg radius-1">
                <ul class="nav nav-tabs justify-content-around" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="tab-1" data-bs-toggle="tab" data-bs-target="#1" type="button" role="tab" aria-controls="home" aria-selected="true">All</button>
                    </li>
                    <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab-2" data-bs-toggle="tab" data-bs-target="#2" type="button" role="tab" aria-controls="profile" aria-selected="false">For Freshers</button>
                    </li>
                    <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab-3" data-bs-toggle="tab" data-bs-target="#3" type="button" role="tab" aria-controls="contact" aria-selected="false">For Working Professionals</button>
                    </li>
                    <li class="nav-item" role="presentation">
                    <button class="nav-link" id="tab-4" data-bs-toggle="tab" data-bs-target="#4" type="button" role="tab" aria-controls="contact" aria-selected="false">Online Courses</button>
                    </li>
                </ul>
                </div>
                <div class="bg-13 p-lg-5 pt-3">
                <div class="container">
                <div class="tab-content mt-3 bg-13" id="myTabContent">
                    <div class="tab-pane fade show active" id="1" role="tabpanel" aria-labelledby="tab-1">
                        <Coursefresher/>
                        <Courseprof/>
                        <Courseonline/>
                    </div>

                    <div class="tab-pane fade" id="2" role="tabpanel" aria-labelledby="tab-2">
                        <Coursefresher/>
                    </div>

                    <div class="tab-pane fade" id="3" role="tabpanel" aria-labelledby="tab-3">
                        <Courseprof/>
                    </div>

                    <div class="tab-pane fade" id="4" role="tabpanel" aria-labelledby="tab-4">
                    <Courseonline/>
                    </div>
                </div>
                </div>
                </div>
                </div>
          </section>
    </main>
    <Enrollaction/>
    <Partnersec/> 
    <Footer/>  
    </div>
  )
}

export default Coursecal